module.exports = __webpack_public_path__ + "img/courier-truxweb.53350744.svg";